import { setExactLoader, setNegativeLoader } from '@/features/bulkActionBtnConfigSlice';
import { IAddToExactConfig, IButtonLoader } from '@/ts/common-types';
import { createKeywords, createNegativeKeywords, validateCreateKeywords } from '@/ts/utils';
import { useSelector } from 'react-redux';

export const useGetBulkActionBtnConfig = (): Record<string, IAddToExactConfig> => {
    const exactLoader = useSelector(
        (state: IButtonLoader) => state.exactLoader.value
    );

    const negativeLoader = useSelector(
        (state: IButtonLoader) => state.negativeLoader.value
    );

    return {
        exact: {
            attribute: "create_target",
            loader: exactLoader,
            setLoader: setExactLoader,
            addFunc: createKeywords,
            validateFunc: validateCreateKeywords,
            isBidRequired: true,
        },
        negativeExact: {
            attribute: "create_negative_target",
            loader: negativeLoader,
            setLoader: setNegativeLoader,
            addFunc: createNegativeKeywords,
            validateFunc: null,
            isBidRequired: false,
        }
    }
}
